import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.exportDialog,
      callback: function ($$v) {
        _vm.exportDialog = $$v;
      },
      expression: "exportDialog"
    }
  }, [_vm.exportDialog ? _c('niota-classic-applications-csv-export', {
    attrs: {
      "applicationId": _vm.applicationObj.id
    },
    on: {
      "close-export-dialog": function ($event) {
        _vm.exportDialog = false;
      }
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.deviceFormDialog,
      callback: function ($$v) {
        _vm.deviceFormDialog = $$v;
      },
      expression: "deviceFormDialog"
    }
  }, [_vm.deviceFormDialog && _vm.editedDevice ? _c('niota-classic-devices-edit-form', {
    attrs: {
      "editedItem": _vm.editedDevice,
      "deviceTypes": _vm.deviceTypes,
      "applications": _vm.applications
    },
    on: {
      "close": function ($event) {
        _vm.deviceFormDialog = false;
      }
    }
  }) : _vm._e()], 1), _c(VRow, {
    staticClass: "list-item-text",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "sm": "12",
      "md": "8",
      "lg": "9"
    }
  }, [_c('div', {
    staticClass: "field mb-6"
  }, [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.description')) + "\n        ")]), _c('br'), _c('span', {
    staticClass: "value"
  }, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.applicationObj.description || _vm.$i18n_t('Common.notAvailable')
    }
  })], 1)])]), _c(VCol, {
    staticClass: "text-right",
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "4",
      "lg": "3"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-file-csv"
    },
    on: {
      "click": function ($event) {
        _vm.exportDialog = true;
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.csv')) + "\n      ")]), _vm.applicationObj.url ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-tachometer-alt-fast"
    },
    on: {
      "click": _vm.openLink
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.visitIotServiceBuilder')) + "\n      ")]) : _vm._e()], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-left pt-0 pl-3 pr-4 pb-4",
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_vm.applicationObj.tags ? _c('div', _vm._l(_vm.applicationObj.tags.split(','), function (item, i) {
    return _c(VChip, {
      key: i,
      staticClass: "ma-1"
    }, [_vm._v("\n              " + _vm._s(item) + "\n            ")]);
  }), 1) : _c('div', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.noTagsAvailable')) + "\n          ")])]), _c(VCol, {
    staticClass: "text-right pt-0 pl-4 pr-4 pb-4",
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c(VBtnToggle, {
    attrs: {
      "rounded": "",
      "color": _vm.color,
      "mandatory": "",
      "dense": ""
    },
    model: {
      value: _vm.reportingPeriodIndex,
      callback: function ($$v) {
        _vm.reportingPeriodIndex = $$v;
      },
      expression: "reportingPeriodIndex"
    }
  }, _vm._l(_vm.reportingPeriods, function (period, index) {
    return _c(VBtn, {
      key: period.value,
      on: {
        "click": function ($event) {
          return _vm.setReportingPeriod(index);
        }
      }
    }, [_vm._v("\n              " + _vm._s(period.text) + "\n            ")]);
  }), 1)], 1)], 1), _c(VRow, [_c('span', {
    staticClass: "set-margin float-left label pb-2"
  }, [_c('h6', {
    staticClass: "card-label shift-right"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.reportingPeriod')))])]), _c('niota-classic-common-n1-card', {
    attrs: {
      "items": _vm.packets,
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.devicesOverview'),
      "subHeader": `(${_vm.selectedPeriod.text})`,
      "icon": "fal fa-analytics"
    }
  }, [_c('niota-classic-common-n1-card-body', {
    attrs: {
      "isLoading": _vm.isLoadingReportingMetics
    }
  }, [!_vm.isLoadingReportingMetics && _vm.reportingMetics.devicesOnlineCount ? _c('niota-classic-charts-pie', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "width": 120,
      "height": 120,
      "chart-data": _vm.overviewPie
    }
  }) : _c('div', {
    staticClass: "centered-message fmedium"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-exclamation-circle")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.noDevices')) + "\n            ")], 1)], 1)], 1), _c('niota-classic-common-n1-card', {
    attrs: {
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.activeDevices'),
      "subHeader": _vm.reportingMetics.devicesOnlineCount,
      "icon": "fal fa-sensor-on"
    }
  }, [_c('niota-classic-common-n1-card-body', {
    attrs: {
      "items": _vm.reportingMetics.onlineDevices,
      "property": 'title',
      "isLoading": _vm.isLoadingReportingMetics
    }
  })], 1), _c('niota-classic-common-n1-card', {
    attrs: {
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.inactiveDevices'),
      "subHeader": _vm.reportingMetics.devicesOfflineCount,
      "icon": "fal fa-wifi-slash"
    }
  }, [_c('niota-classic-common-n1-card-body', {
    attrs: {
      "items": _vm.reportingMetics.offlineDevices,
      "property": 'title',
      "isLoading": _vm.isLoadingReportingMetics
    }
  })], 1), _c('niota-classic-common-n1-card', {
    attrs: {
      "items": _vm.packets,
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.liveViewer'),
      "subHeader": _vm.wsConnected ? `Online${!_vm.websocketPackets.length ? ' (' + _vm.$i18n_t('NiotaClassic.Applications.details.waitingPackets') + ')' : ''}` : _vm.$i18n_t('NiotaClassic.Applications.details.connecting'),
      "icon": "fal fa-arrows-v"
    }
  }, [_c('niota-classic-common-n1-card-body', {
    attrs: {
      "items": _vm.websocketPackets,
      "packets": true,
      "isLoading": !_vm.wsConnected || !_vm.websocketPackets.length,
      "infoProperty1": 'source_time',
      "property": 'device_name'
    }
  })], 1)], 1), _c(VRow, [_vm.showOrHideDetails('nominal') ? _c('span', {
    staticClass: "card-label-left set-margin label pb-2"
  }, [_c('h6', {
    staticClass: "card-label shift-right"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.activeDevice24hrs')))])]) : _vm._e(), _vm.showOrHideDetails('nominal') ? _c('niota-classic-common-n1-card', {
    attrs: {
      "items": _vm.packets,
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.devicesOverview'),
      "icon": "fal fa-analytics"
    }
  }, [_c('niota-classic-common-n1-card-body', {
    attrs: {
      "isLoading": _vm.isLoadingReportingMetics
    }
  }, [!_vm.isLoadingReportingMetics && _vm.reportingMetics.nominalDevicesCount ? _c('niota-classic-charts-pie', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "width": 120,
      "height": 120,
      "chart-data": _vm.nominalDevicesPie
    }
  }) : _vm._e(), !_vm.isLoadingReportingMetics && !_vm.reportingMetics.nominalDevicesCount ? _c('div', {
    staticClass: "centered-message fmedium"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-exclamation-circle")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.noDevices')) + "\n            ")], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm.showOrHideDetails('nominal') ? _c('niota-classic-common-n1-card', {
    attrs: {
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.nominalDevices'),
      "subHeader": _vm.reportingMetics.nominalDevicesCount || 0,
      "icon": "fal fa-sensor-smoke"
    }
  }, [_c('niota-classic-common-n1-card-body', {
    attrs: {
      "isLoading": _vm.isLoadingReportingMetics
    }
  }, [_c('ul', {
    staticClass: "list-unstyled list-info application-overview-packet-list"
  }, _vm._l(_vm.reportingMetics.nominalDevices, function (device) {
    return _c('li', {
      key: device.id
    }, [_c('div', {
      staticClass: "info-box appDetails hover clickable",
      on: {
        "click": function ($event) {
          return _vm.viewDevice(device.device_id);
        }
      }
    }, [_c('div', {
      staticClass: "info-heading",
      staticStyle: {
        "color": "green !important",
        "font-weight": "500"
      }
    }, [_c(VIcon, {
      staticClass: "dyn-elipsis info-heading-icon",
      staticStyle: {
        "margin-top": "-3px"
      },
      attrs: {
        "color": "green"
      }
    }, [_vm._v("\n                      fal fa-inbox-in\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.sent')) + ": " + _vm._s(device.count_packets) + " -\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.threshold')) + ":\n                    " + _vm._s(device.threshold) + "\n                  ")], 1), _c('div', {
      staticClass: "fmedium dyn-elipsis"
    }, [_c('router-link', {
      attrs: {
        "to": `/niota-classic/devices/${device.id}/details`
      }
    }, [_vm._v("\n                      " + _vm._s(device.title) + "\n                    ")])], 1)])]);
  }), 0), !_vm.isLoadingReportingMetics && !_vm.reportingMetics.nominalDevicesCount ? _c('div', {
    staticClass: "centered-message fmedium"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-exclamation-circle")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.noDevices')) + "\n            ")], 1) : _vm._e()])], 1) : _vm._e(), _vm.showOrHideDetails('nominal') ? _c('niota-classic-common-n1-card', {
    attrs: {
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.NonNominalAndUnset'),
      "subHeader": _vm.reportingMetics.notNominalDevicesCount || 0,
      "icon": "fal fa-sensor-alert"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('div', {
          staticClass: "filter-not-nominal-sensor",
          staticStyle: {
            "margin-top": "-4px"
          }
        }, [_c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('notNominal', _vm.reportingMetics.notNominalDevicesBelowThresholdDeviceIds);
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-sensor-alert")]), _c('span', {
          staticClass: "badge badge-danger badge-custom"
        }, [_vm._v("\n                  " + _vm._s(_vm.reportingMetics.notNominalDevices ? _vm.reportingMetics.notNominalDevicesBelowThresholdDeviceIds.length : 0) + "\n                ")])], 1), _c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('notNominal', _vm.reportingMetics.notNominalDevicesNoThresholdDeviceIds);
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          staticStyle: {
            "color": "orange"
          },
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-sensor-alert")]), _c('span', {
          staticClass: "badge badge-warning badge-custom"
        }, [_vm._v("\n                  " + _vm._s(_vm.reportingMetics.notNominalDevices ? _vm.reportingMetics.notNominalDevicesNoThresholdDeviceIds.length : 0) + "\n                ")])], 1), _c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('notNominal');
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-undo")])], 1)])];
      },
      proxy: true
    }], null, false, 3012413932)
  }, [_c('niota-classic-common-n1-card-body', {
    attrs: {
      "isLoading": _vm.isLoadingReportingMetics || _vm.isLoadingNotNominal
    }
  }, [_c('ul', {
    staticClass: "list-unstyled list-info application-overview-packet-list"
  }, _vm._l(_vm.notNominalDevicesList, function (device) {
    return _c('li', {
      key: device.id
    }, [_c('div', {
      staticClass: "info-box appDetails hover clickable flat-right-border",
      on: {
        "click": function ($event) {
          return _vm.viewDevice(device.id);
        }
      }
    }, [_c('div', {
      staticClass: "info-heading",
      style: {
        color: (!device.threshold ? 'orange' : 'red') + '!important'
      }
    }, [_c(VIcon, {
      staticClass: "dyn-elipsis info-heading-icon",
      staticStyle: {
        "margin-top": "-3px"
      },
      style: {
        color: (!device.threshold ? 'orange' : 'red') + '!important'
      }
    }, [_vm._v("\n                      fal fa-exclamation-triangle\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.sent')) + ": " + _vm._s(device.count_packets) + " -\n                    " + _vm._s(device.threshold ? `${_vm.$i18n_t('NiotaClassic.Applications.details.threshold')}:` + device.threshold : _vm.$i18n_t('NiotaClassic.Applications.details.noThreshold')) + "\n                  ")], 1), _c('div', {
      staticClass: "fmedium dyn-elipsis"
    }, [_c('router-link', {
      attrs: {
        "to": `/niota-classic/devices/${device.id}/details`
      }
    }, [_vm._v("\n                      " + _vm._s(device.title) + "\n                    ")])], 1)]), _vm.isIotHubManager ? _c('div', {
      staticClass: "info-box edit-button-box",
      on: {
        "click": function ($event) {
          return _vm.editDevice(device.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "text-right edit-device-icon clickable",
      attrs: {
        "small": ""
      }
    }, [_vm._v("fal fa-edit")])], 1) : _vm._e()]);
  }), 0), !_vm.isLoadingReportingMetics && !_vm.reportingMetics.notNominalDevicesCount ? _c('div', {
    staticClass: "centered-message fmedium"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-exclamation-circle")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.noDevices')) + "\n            ")], 1) : _vm._e()])], 1) : _vm._e(), _vm.showOrHideDetails('status') ? _c('span', {
    staticClass: "set-margin float-left label pb-2"
  }, [_c('h6', {
    staticClass: "card-label shift-right"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.operationalStatus')))])]) : _vm._e(), _vm.showOrHideDetails('status') ? _c('niota-classic-common-n1-card', {
    attrs: {
      "subHeader": _vm.customDevicesResponse.deviceCount || 0,
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.statusOverview'),
      "icon": "fal fa-sensor"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('div', {
          staticClass: "filter-not-nominal-sensor",
          staticStyle: {
            "margin-top": "-4px"
          }
        }, [_c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('operational', _vm.customDevicesResponse.notOperationalDeviceIds);
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-sensor")]), _c('span', {
          staticClass: "badge badge-danger badge-custom"
        }, [_vm._v("\n                  " + _vm._s(_vm.customDevicesResponse.countNotOperationalDevices || 0) + "\n                ")])], 1), _c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('operational', _vm.customDevicesResponse.noOperationalStatusDeviceIds);
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          staticStyle: {
            "color": "orange"
          },
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-sensor")]), _c('span', {
          staticClass: "badge badge-warning badge-custom"
        }, [_vm._v("\n                  " + _vm._s(_vm.customDevicesResponse.countNoOperationalStatusDevices || 0) + "\n                ")])], 1), _c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('operational', _vm.customDevicesResponse.inOperationDeviceIds);
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          staticStyle: {
            "color": "green"
          },
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-sensor")]), _c('span', {
          staticClass: "badge badge-success badge-custom"
        }, [_vm._v("\n                  " + _vm._s(_vm.customDevicesResponse.countInOperationDevices || 0) + "\n                ")])], 1), _c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('operational');
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-undo")])], 1)])];
      },
      proxy: true
    }], null, false, 2899058806)
  }, [_c('niota-classic-common-n1-card-body', {
    attrs: {
      "isLoading": _vm.isLoadingCustomDevices
    }
  }, [_c('ul', {
    staticClass: "list-unstyled list-info application-overview-packet-list"
  }, _vm._l(_vm.customDevices, function (device) {
    return _c('li', {
      key: device.id
    }, [_c('div', {
      staticClass: "info-box appDetails hover clickable flat-right-border",
      on: {
        "click": function ($event) {
          return _vm.viewDevice(device.id);
        }
      }
    }, [_c('div', {
      staticClass: "info-heading",
      style: {
        color: device.textColor + '!important'
      }
    }, [_c(VIcon, {
      staticClass: "dyn-elipsis info-heading-icon",
      staticStyle: {
        "margin-top": "-3px"
      },
      style: {
        color: device.textColor + '!important'
      }
    }, [_vm._v("\n                      fal fa-exclamation-triangle\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.sent')) + ": " + _vm._s(device.count_packets) + " -\n                    " + _vm._s(_vm.getDeviceStatus(device)) + "\n                  ")], 1), _c('div', {
      staticClass: "fmedium dyn-elipsis"
    }, [_c('router-link', {
      attrs: {
        "to": `/niota-classic/devices/${device.id}/details`
      }
    }, [_vm._v("\n                      " + _vm._s(device.title) + "\n                    ")])], 1)]), _vm.isIotHubManager ? _c('div', {
      staticClass: "info-box edit-button-box",
      on: {
        "click": function ($event) {
          return _vm.editDevice(device.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "text-right edit-device-icon clickable",
      attrs: {
        "small": ""
      }
    }, [_vm._v("fal fa-edit")])], 1) : _vm._e()]);
  }), 0), !_vm.isLoadingCustomDevices && !_vm.customDevices.length ? _c('div', {
    staticClass: "centered-message fmedium"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-exclamation-circle")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.noDevices')) + "\n            ")], 1) : _vm._e()])], 1) : _vm._e()], 1), _c(VRow, [_c('span', {
    staticClass: "card-label-left set-margin label pb-2"
  }, [_c('h6', {
    staticClass: "card-label shift-right"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.batteryStatus')))])]), _c('niota-classic-common-n1-card', {
    attrs: {
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.unsetBatteryLevel'),
      "subHeader": _vm.devicesBatteryGroupsCount.unsetDevices,
      "icon": "fal fa-battery-slash"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('div', {
          staticClass: "filter-not-nominal-sensor",
          staticStyle: {
            "margin-top": "-4px"
          }
        }, [_c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('unsetBattery', _vm.devicesBatteryResponse.withoutTypeDeviceIds);
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-cubes")]), _c('span', {
          staticClass: "badge badge-danger badge-custom"
        }, [_vm._v("\n                  " + _vm._s(_vm.devicesBatteryGroupsCount.withoutType || 0) + "\n                ")])], 1), _c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('unsetBattery', _vm.devicesBatteryResponse.withoutLevelDeviceIds);
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          staticStyle: {
            "color": "orange"
          },
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-siren-on")]), _c('span', {
          staticClass: "badge badge-warning badge-custom"
        }, [_vm._v("\n                  " + _vm._s(_vm.devicesBatteryGroupsCount.withoutAlertLevel || 0) + "\n                ")])], 1), _c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('unsetBattery');
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-undo")])], 1)])];
      },
      proxy: true
    }])
  }, [_c('niota-classic-common-n1-card-body', {
    attrs: {
      "isLoading": _vm.isLoadingDevicesBattery || _vm.isLoadingUnsetDevicesBattery
    }
  }, [_c('ul', {
    staticClass: "list-unstyled list-info application-overview-packet-list"
  }, _vm._l(_vm.unsetBatteryDevices, function (device) {
    return _c('li', {
      key: device.id
    }, [_c('div', {
      staticClass: "info-box appDetails hover clickable",
      on: {
        "click": function ($event) {
          return _vm.viewDevice(device.id);
        }
      }
    }, [_c('div', {
      staticClass: "info-heading",
      style: {
        color: device.textColor + '!important'
      }
    }, [_c(VIcon, {
      staticClass: "dyn-elipsis info-heading-icon",
      staticStyle: {
        "margin-top": "-3px"
      },
      style: {
        color: device.textColor + '!important'
      }
    }, [_vm._v("\n                      fal fa-exclamation-triangle\n                    ")]), _vm._v("\n                    " + _vm._s(device.textColor === 'red' ? _vm.$i18n_t('NiotaClassic.Applications.details.noDeviceType') : _vm.$i18n_t('NiotaClassic.Applications.details.noBatteryLevel')) + "\n                  ")], 1), _c('div', {
      staticClass: "fmedium dyn-elipsis"
    }, [_c('router-link', {
      attrs: {
        "to": `/niota-classic/devices/${device.id}/details`
      }
    }, [_vm._v("\n                      " + _vm._s(device.title) + "\n                    ")])], 1)])]);
  }), 0), !(_vm.isLoadingDevicesBattery || _vm.isLoadingUnsetDevicesBattery) && !_vm.unsetBatteryDevices.length ? _c('div', {
    staticClass: "centered-message fmedium"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-exclamation-circle")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.noDevices')) + "\n            ")], 1) : _vm._e()])], 1), _c('niota-classic-common-n1-card', {
    attrs: {
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.batteryNotification'),
      "subHeader": _vm.devicesBatteryResponse.countAllBatteryAlerts,
      "icon": "fal fa-battery-three-quarters"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('div', {
          staticClass: "filter-not-nominal-sensor",
          staticStyle: {
            "margin-top": "-4px"
          }
        }, [_c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('setBattery', _vm.devicesBatteryResponse.alertDeviceIds);
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-siren-on")]), _c('span', {
          staticClass: "badge badge-danger badge-custom"
        }, [_vm._v("\n                  " + _vm._s(_vm.devicesBatteryResponse.countDevicesWithAlert || 0) + "\n                ")])], 1), _c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('setBattery', _vm.devicesBatteryResponse.warningDeviceIds);
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          staticStyle: {
            "color": "orange"
          },
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-siren-on")]), _c('span', {
          staticClass: "badge badge-warning badge-custom"
        }, [_vm._v("\n                  " + _vm._s(_vm.devicesBatteryResponse.countDevicesWithWarning || 0) + "\n                ")])], 1), _c('span', {
          staticClass: "filter-icons",
          on: {
            "click": function ($event) {
              return _vm.filterDevices('setBattery');
            }
          }
        }, [_c(VIcon, {
          staticClass: "font-weight-0",
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-undo")])], 1)])];
      },
      proxy: true
    }])
  }, [_c('niota-classic-common-n1-card-body', {
    attrs: {
      "isLoading": _vm.isLoadingDevicesBattery || _vm.isLoadingSetDevicesBattery
    }
  }, [_c('ul', {
    staticClass: "list-unstyled list-info application-overview-packet-list"
  }, _vm._l(_vm.setBatteryDevices, function (device) {
    return _c('li', {
      key: device.id
    }, [_c('div', {
      staticClass: "info-box appDetails hover clickable",
      on: {
        "click": function ($event) {
          return _vm.viewDevice(device.id);
        }
      }
    }, [_c('div', {
      staticClass: "info-heading",
      style: {
        color: device.textColor + '!important'
      }
    }, [_c(VIcon, {
      staticClass: "dyn-elipsis info-heading-icon",
      staticStyle: {
        "margin-top": "-3px"
      },
      style: {
        color: device.textColor + '!important'
      }
    }, [_vm._v("\n                      fal fa-exclamation-triangle\n                    ")]), _vm._v("\n                    " + _vm._s(device.textColor === 'red' ? 'REPLACE BATTERY "CRITICAL"' : 'CHECK BATTERY') + "\n                  ")], 1), _c('div', {
      staticClass: "fmedium dyn-elipsis"
    }, [_c('router-link', {
      attrs: {
        "to": `/niota-classic/devices/${device.id}/details`
      }
    }, [_vm._v("\n                      " + _vm._s(device.title) + "\n                    ")])], 1)])]);
  }), 0), !(_vm.isLoadingDevicesBattery || _vm.isLoadingUnsetDevicesBattery) && !_vm.setBatteryDevices.length ? _c('div', {
    staticClass: "centered-message fmedium"
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-exclamation-circle")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.noDevices')) + "\n            ")], 1) : _vm._e()])], 1)], 1), _c(VRow, [_vm.showOrHideDetails('statistics') ? _c('niota-classic-common-n1-card', {
    attrs: {
      "header": _vm.$i18n_t('NiotaClassic.Applications.details.statisticsReport'),
      "col": {
        cols: 12,
        sm: 12,
        md: 12,
        lg: 12
      },
      "icon": "fal fa-presentation"
    }
  }, [_c('niota-classic-common-n1-card-body', {
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "isLoading": _vm.isLoadingHistoryMetrics,
      "maxHeight": true
    }
  }, [!_vm.isLoadingHistoryMetrics ? [_c('niota-classic-applications-statistics-report', {
    attrs: {
      "statisticsObj": _vm.statistics,
      "customPeriod": _vm.fullMetrics.daily.length || _vm.fullMetrics.daily_previous_Period.length
    }
  })] : _vm._e()], 2)], 1) : _vm._e()], 1), _c(VCardText, {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.packetPerHour')))])])])], 1)], 1), !_vm.isLoadingHistoryMetrics ? _c('niota-classic-charts-bar', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.hourlyPacketsgraph,
      "chart-data-t": _vm.hourlyPacketsgraph,
      "options": _vm.hourlyPacketsgraphOptions
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@3"
    }
  }), _c(VCardText, {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.packetPerDay')))])])])], 1)], 1), !_vm.isLoadingHistoryMetrics ? _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.dailyPacketsgraph,
      "chart-data-t": _vm.dailyPacketsgraph,
      "options": _vm.dailyPacketsgraphOptions
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@3"
    }
  }), _c(VCardText, {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v("RSSI/SNR")])])])], 1)], 1), !_vm.isLoadingHistoryMetrics ? _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.snrGraph
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@3"
    }
  }), _vm.showOrHideDetails('SFgraph') ? _c(VCardText, {
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v("\n                Spreading Factor (SF)(" + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.Average')) + ":\n                " + _vm._s(_vm.spreadingFactorAverage.toFixed(2)) + ")\n              ")])])])], 1)], 1) : _vm._e(), !_vm.isLoadingHistoryMetrics && _vm.showOrHideDetails('SFgraph') ? _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "chart-data-t": _vm.spreadingFactorGraph,
      "options": _vm.spreadingFactorGraphOptions
    }
  }) : _vm.isLoadingHistoryMetrics ? _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@3"
    }
  }) : _vm._e(), _vm.applicationObj.id && _vm.applicationObj.deviceCount && _vm.applicationObj.deviceCount !== '0' || _vm.hideMapTrigger ? _c(VCardText, {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.details.sensorsLocationsMapsHeader')))])])])], 1)], 1) : _vm._e(), _vm.applicationObj.id && _vm.applicationObj.deviceCount && _vm.applicationObj.deviceCount !== '0' ? _c('niota-classic-applications-map', {
    attrs: {
      "applicationObj": _vm.applicationObj,
      "interactiveMap": true
    },
    on: {
      "hide-map": _vm.hideMap
    }
  }) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };